import React, { useState } from 'react';


import VideoCard from '../../../components/VideoCard';


const ContentCard = ({ content, rank, onWhatsAppRequest }) => {
  return (
    <VideoCard
      content={content}
      rank={rank}
      showRankBadge={true}
      onWhatsAppRequest={onWhatsAppRequest}
      variant="hall-of-fame"
      onContentClick={() => {}}
      onRatingChange={() => {}}
    />
  );
};

export default ContentCard;